import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderExecutionNg extends BaseModelAPI {
	static entity = 'workorderexecutionng';
	static entityName = 'workorderexecutionng';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.ngCategoryId = '';
			this.ngCategory = {};
			this.ngQty = 0;
			this.workOrderExecutionDetailId = '';
			this.workOrderExecutionDetail = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}